import type { InvoicedEntity } from '@/types/company';
import type { Option } from '@components/forms/GridSelect';

export const enum BillingType {
    CutFee = 0,
    NoCutFee = 1,
}

export const enum WarrantyType {
    Warranty = 0,
    NoWarranty = 1,
}

export const enum UISelection {
    Standard = 1,
    Advanced = 2,
}

export const enum TrackingType {
    None = 1,
    Pilot = 2,
}

export const BILLING_OPTIONS: Option[] = [
    {
        label: 'Cut Fee Included in Sheets',
        value: BillingType.CutFee,
    },
    {
        label: 'Cut Fee Not Included in Sheets',
        value: BillingType.NoCutFee,
    },
];

export const WARRANTY_OPTIONS: Option[] = [
    {
        label: 'Warranty',
        value: WarrantyType.Warranty,
    },
    {
        label: 'No Warranty',
        value: WarrantyType.NoWarranty,
    },
];

export const TRACKING_TYPE_OPTIONS: Option[] = [
    {
        label: 'None',
        value: TrackingType.None,
    },
    {
        label: 'Pilot',
        value: TrackingType.Pilot,
    },
];

export const DEFAULT_BILLING_OPTIONS: InvoicedEntity = {
    CutPlanID: BillingType.CutFee,
    WarrantyPlanID: WarrantyType.Warranty,
};

export const CUT_FEE_MAP: Record<BillingType, string> = {
    [BillingType.CutFee]: 'Cut Fee Not Included in Sheets',
    [BillingType.NoCutFee]: 'Cut Fee Included in Sheets',
};

export const WARRANTY_PLAN_MAP: Record<WarrantyType, string> = {
    [WarrantyType.NoWarranty]: 'Warranty Disabled',
    [WarrantyType.Warranty]: 'Warranty Enabled',
};

export const UI_SELECTION_MAP: Record<UISelection, string> = {
    [UISelection.Standard]: 'Standard',
    [UISelection.Advanced]: 'Advanced',
};

export const TRACKING_TYPE_MAP: Record<TrackingType, string> = {
    [TrackingType.None]: 'None',
    [TrackingType.Pilot]: 'Pilot',
};
